// Simplified version of https://github.com/MetaMask/metamask-extension/blob/master/ui/helpers/utils/icon-factory.js
let identiconFactory

export default function identiconFactoryGenerator (jazzicon) {
  if (!identiconFactory) {
    identiconFactory = new IdenticonFactory(jazzicon)
  }
  return identiconFactory
}

class IdenticonFactory {
  constructor (jazzicon) {
    this.jazzicon = jazzicon
    this.cache = {}
  }

  iconForAddress (address, diameter) {
    return this.generateIdenticonSvg(address, diameter)
  }

  // returns svg dom element
  generateIdenticonSvg (address, diameter) {
    const cacheId = `${address}:${diameter}`
    // check cache, lazily generate and populate cache
    const identicon =
      this.cache[cacheId] ||
      (this.cache[cacheId] = this.generateNewIdenticon(address, diameter))
    // create a clean copy so you can modify it
    const cleanCopy = identicon.cloneNode(true)
    return cleanCopy
  }

  // creates a new identicon
  generateNewIdenticon (address, diameter) {
    const numericRepresentation = jsNumberForAddress(address)
    const identicon = this.jazzicon(diameter, numericRepresentation)
    return identicon
  }
}

// util
function jsNumberForAddress (address) {
  const addr = address.slice(2, 10)
  const seed = parseInt(addr, 16)
  return seed
}
